import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "ProjectComments" }
const _hoisted_2 = { class: "ProjectComments__list" }

import { computed, PropType } from "vue";
import { Project } from "@/types";
import InnSection from "@/components/general/Section.vue";
import ProjectComment from "@/components/pages/project/comments/ProjectComment.vue";
import ProjectCommentCreate from "@/components/pages/project/comments/ProjectCommentCreate.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectComments',
  props: {
    project: {
        type: Object as PropType<Project>,
        required: true,
    },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(InnSection, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.project.comments, (comment, index) => {
            return (_openBlock(), _createBlock(ProjectComment, {
              key: index,
              comment: comment
            }, null, 8, ["comment"]))
          }), 128))
        ]),
        _createVNode(ProjectCommentCreate, { project: __props.project }, null, 8, ["project"])
      ]),
      _: 1
    })
  ]))
}
}

})